import {logWarn} from "../../components/model/utils";
import {appdata} from "../../logic_tmp/appdata/AppData";

// Функция для инициализации PixelManager
async function initPixelManager() {
    if (typeof window.PixelManager === 'undefined') {
        try {
            const script = document.createElement('script');
            script.src = '/js/event-bridge.js';
            script.async = true;
            document.head.appendChild(script);
            
            await new Promise((resolve, reject) => {
                script.onload = resolve;
                script.onerror = reject;
            });
        } catch (error) {
            logWarn('Error to load event-bridge.js:', error);
            throw error;
        }
    }
}

// Функция для конвертации символа валюты в код
function convertCurrencyToCode(currency) {
    const currencyMap = {
        '€': 'EUR',
        '$': 'USD',
        '£': 'GBP',
        '¥': 'JPY',
        '₽': 'RUB'
    };
    return currencyMap[currency] || currency;
}

export async function testFunnel() {
    // Здесь можно добавить тестовую логику для воронки
}

export async function registerConcersion(pixelKey, logKey) {
    try {
        // Инициализируем PixelManager
        await initPixelManager();

        // Конвертируем валюту в код
        const currency = convertCurrencyToCode(appdata.product?.currency || 'EUR');

        // Отправляем событие через PixelManager
        await window.PixelManager.sendEvent(pixelKey, {
            content_name: appdata.product?.productData?.productNameKey || '',
            content_category: appdata.product?.type || '',
            content_ids: [appdata.product?.productCode || ''],
            currency: currency,
            value: appdata.amount || 0
        }, {
            email: appdata.customerEmail,
            phone: appdata.customerPhone
        });

    } catch (error) {
        console.error('Error:', error.stack);
        logWarn(logKey, error.message);
        throw error;
    }
}



